import React, { useCallback, useEffect, useMemo } from 'react';

import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import { useMediaQuery } from 'react-responsive';
import HeaderSteps from './components/HeaderSteps';

import SelectBases from '../Steps/SelectBases';
import FuelLevel from '../Steps/FuelLevel';
import ScheduleDate from '../Steps/ScheduleDate';
import ResponsibleData from '../Steps/ResponsibleData';
import ConfirmRefuel from '../Steps/ConfirmRefuel';

import { useNewRefuel } from '../hooks/useNewRefuel';

import BaseSelectedMobile from './components/BaseSelectedMobile';

import { menuItems } from '../providers';

import TooltipHeader from './components/FuelLevelSelect/components/TooltipHeader';
import ModalError from './ModalError';
import HeaderStepsMobile from './components/HeaderStepsMobile';

import {
  Container,
  Header,
  Title,
  SubTitle,
  StepsWrapper,
  ContainerWrap,
  ControlsWrap,
  ButtonConfirm,
  ButtonCancel,
  HeaderText,
  ModalStyled,
  StepsMobileWrapper,
  ContainerBasesWrapper,
  BasesWrapper,
} from './styles';
import CardHeader from './components/FuelLevelSelect/components/CardHeader';

const RefuelContainer: React.FC = () => {
  const [showModal, setShowModal] = React.useState(false);
  const {
    enabledStep,
    handleEnabledStep,
    stepError,
    confirmRefuels,
    selectedBases,
    selectedBase,
    finishRefuel,
  } = useNewRefuel();

  const isMobile = useMediaQuery({ maxWidth: 768 });

  const onPrev = useCallback(() => {
    handleEnabledStep(enabledStep + 1);
  }, [enabledStep, handleEnabledStep]);

  const onBack = useCallback(() => {
    handleEnabledStep(enabledStep - 1);
  }, [enabledStep, handleEnabledStep]);

  const handleNext = (): void => {
    onPrev();
    setShowModal(stepError > 0 && stepError === enabledStep);
  };

  const ContentComponent = useMemo(() => {
    switch (enabledStep) {
      case 1:
        return <SelectBases />;
      case 2:
        return <FuelLevel />;
      case 3:
        return <ScheduleDate />;
      case 4:
        return <ResponsibleData />;
      case 5:
        return <ConfirmRefuel />;
      default:
        return null;
    }
  }, [enabledStep]);

  useEffect(() => {
    setShowModal(stepError > 0 && stepError === enabledStep);
  }, [stepError, enabledStep]);

  return (
    <Navbar selected="pedido-abastecimento" openSubMenu="abastecimento">
      <UserMenu intro={() => true} />
      <Container>
        <Header>
          <HeaderText>
            <Title>Novo pedido</Title>
            <SubTitle>
              Siga as etapas abaixo para que possamos efetuar seu pedido
            </SubTitle>
          </HeaderText>
          {!isMobile && enabledStep >= 2 && <TooltipHeader />}
        </Header>
        {!isMobile && (
          <StepsWrapper>
            <HeaderSteps steps={menuItems} activeStep={enabledStep} />
          </StepsWrapper>
        )}
        {isMobile && (
          <StepsMobileWrapper>
            <HeaderStepsMobile steps={menuItems} activeStep={enabledStep} />
          </StepsMobileWrapper>
        )}
        {isMobile && enabledStep >= 2 && <CardHeader />}
        <ContainerBasesWrapper>
          {isMobile && enabledStep > 1 && (
            <BasesWrapper>
              {selectedBases.length > 0 &&
                selectedBases.map((base) => {
                  const isComplete = (): boolean => {
                    const idx = selectedBases.findIndex(
                      (item) => item.name === base.name
                    );

                    if (idx === -1) return false;

                    if (enabledStep === 2)
                      return selectedBases[idx].percentageValidate || false;
                    if (enabledStep === 3)
                      return selectedBases[idx].dateValidate || false;
                    if (enabledStep === 3 || enabledStep === 4) return true;
                    if (enabledStep === 5) return true;

                    return false;
                  };

                  const isError = (): boolean => {
                    const idx = selectedBases.findIndex(
                      (item) => item.name === base.name
                    );

                    if (idx === -1) return false;

                    if (enabledStep === 2 && stepError === 2)
                      return !selectedBases[idx].percentageValidate;

                    if (enabledStep === 3 && stepError === 3)
                      return !selectedBases[idx].dateValidate;

                    if (
                      (enabledStep === 4 || enabledStep === 5) &&
                      (stepError === 4 || stepError === 5)
                    )
                      return false;

                    return false;
                  };

                  const isSelect = (): boolean => {
                    if (enabledStep === 4) return false;

                    return base.name === selectedBase?.name;
                  };

                  return (
                    <BaseSelectedMobile
                      key={base.name}
                      isSelected={isSelect()}
                      baseName={base.name}
                      nickName={base.nickname}
                      isComplete={isComplete()}
                      isError={isError()}
                    />
                  );
                })}
            </BasesWrapper>
          )}
          <ContainerWrap>{ContentComponent}</ContainerWrap>
        </ContainerBasesWrapper>
        <ControlsWrap>
          <ButtonCancel disabled={enabledStep === 1} onClick={onBack}>
            Voltar
          </ButtonCancel>
          <ButtonConfirm
            onClick={() => {
              if (menuItems.length - 1 === enabledStep) {
                confirmRefuels();
              }
              if (menuItems.length === enabledStep) {
                finishRefuel();
                return;
              }
              handleNext();
            }}
          >
            {menuItems.length === enabledStep ? 'Concluir' : 'Próximo'}
          </ButtonConfirm>
        </ControlsWrap>
        <ModalStyled
          show={showModal}
          onHide={() => setShowModal(false)}
          animation={false}
          centered
        >
          <ModalError
            closeModal={() => setShowModal(false)}
            stepError={stepError}
          />
        </ModalStyled>
      </Container>
    </Navbar>
  );
};

export default RefuelContainer;
